import { TranslocoService } from '@jsverse/transloco';
import { ConsumptionFilter } from '../../stores/consumption.store';
import * as echarts from 'echarts';

// demo data taken from chartmify repo
const data: Record<ConsumptionFilter['granularity'], { xAxis: string[]; yAxis: number[] }> = {
  YEAR: {
    xAxis: [
      '2025-12-31',
      '2026-01-01',
      '2026-01-02',
      '2026-01-03',
      '2026-01-04',
      '2026-01-05',
      '2026-01-06',
      '2026-01-07',
      '2026-01-08',
      '2026-01-09',
      '2026-01-10',
      '2026-01-11',
      '2026-01-12',
      '2026-01-13',
      '2026-01-14',
      '2026-01-15',
      '2026-01-16',
      '2026-01-17',
      '2026-01-18',
      '2026-01-19',
      '2026-01-20',
      '2026-01-21',
      '2026-01-22',
      '2026-01-23',
      '2026-01-24',
      '2026-01-25',
      '2026-01-26',
      '2026-01-27',
      '2026-01-28',
      '2026-01-29',
      '2026-01-30',
      '2026-01-31',
      '2026-02-01',
      '2026-02-02',
      '2026-02-03',
      '2026-02-04',
      '2026-02-05',
      '2026-02-06',
      '2026-02-07',
      '2026-02-08',
      '2026-02-09',
      '2026-02-10',
      '2026-02-11',
      '2026-02-12',
      '2026-02-13',
      '2026-02-14',
      '2026-02-15',
      '2026-02-16',
      '2026-02-17',
      '2026-02-18',
      '2026-02-19',
      '2026-02-20',
      '2026-02-21',
      '2026-02-22',
      '2026-02-23',
      '2026-02-24',
      '2026-02-25',
      '2026-02-26',
      '2026-02-27',
      '2026-02-28',
      '2026-03-01',
      '2026-03-02',
      '2026-03-03',
      '2026-03-04',
      '2026-03-05',
      '2026-03-06',
      '2026-03-07',
      '2026-03-08',
      '2026-03-09',
      '2026-03-10',
      '2026-03-11',
      '2026-03-12',
      '2026-03-13',
      '2026-03-14',
      '2026-03-15',
      '2026-03-16',
      '2026-03-17',
      '2026-03-18',
      '2026-03-19',
      '2026-03-20',
      '2026-03-21',
      '2026-03-22',
      '2026-03-23',
      '2026-03-24',
      '2026-03-25',
      '2026-03-26',
      '2026-03-27',
      '2026-03-28',
      '2026-03-29',
      '2026-03-30',
      '2026-03-31',
      '2026-04-01',
      '2026-04-02',
      '2026-04-03',
      '2026-04-04',
      '2026-04-05',
      '2026-04-06',
      '2026-04-07',
      '2026-04-08',
      '2026-04-09',
      '2026-04-10',
      '2026-04-11',
      '2026-04-12',
      '2026-04-13',
      '2026-04-14',
      '2026-04-15',
      '2026-04-16',
      '2026-04-17',
      '2026-04-18',
      '2026-04-19',
      '2026-04-20',
      '2026-04-21',
      '2026-04-22',
      '2026-04-23',
      '2026-04-24',
      '2026-04-25',
      '2026-04-26',
      '2026-04-27',
      '2026-04-28',
      '2026-04-29',
      '2026-04-30',
      '2026-05-01',
      '2026-05-02',
      '2026-05-03',
      '2026-05-04',
      '2026-05-05',
      '2026-05-06',
      '2026-05-07',
      '2026-05-08',
      '2026-05-09',
      '2026-05-10',
      '2026-05-11',
      '2026-05-12',
      '2026-05-13',
      '2026-05-14',
      '2026-05-15',
      '2026-05-16',
      '2026-05-17',
      '2026-05-18',
      '2026-05-19',
      '2026-05-20',
      '2026-05-21',
      '2026-05-22',
      '2026-05-23',
      '2026-05-24',
      '2026-05-25',
      '2026-05-26',
      '2026-05-27',
      '2026-05-28',
      '2026-05-29',
      '2026-05-30',
      '2026-05-31',
      '2026-06-01',
      '2026-06-02',
      '2026-06-03',
      '2026-06-04',
      '2026-06-05',
      '2026-06-06',
      '2026-06-07',
      '2026-06-08',
      '2026-06-09',
      '2026-06-10',
      '2026-06-11',
      '2026-06-12',
      '2026-06-13',
      '2026-06-14',
      '2026-06-15',
      '2026-06-16',
      '2026-06-17',
      '2026-06-18',
      '2026-06-19',
      '2026-06-20',
      '2026-06-21',
      '2026-06-22',
      '2026-06-23',
      '2026-06-24',
      '2026-06-25',
      '2026-06-26',
      '2026-06-27',
      '2026-06-28',
      '2026-06-29',
      '2026-06-30',
      '2026-07-01',
      '2026-07-02',
      '2026-07-03',
      '2026-07-04',
      '2026-07-05',
      '2026-07-06',
      '2026-07-07',
      '2026-07-08',
      '2026-07-09',
      '2026-07-10',
      '2026-07-11',
      '2026-07-12',
      '2026-07-13',
      '2026-07-14',
      '2026-07-15',
      '2026-07-16',
      '2026-07-17',
      '2026-07-18',
      '2026-07-19',
      '2026-07-20',
      '2026-07-21',
      '2026-07-22',
      '2026-07-23',
      '2026-07-24',
      '2026-07-25',
      '2026-07-26',
      '2026-07-27',
      '2026-07-28',
      '2026-07-29',
      '2026-07-30',
      '2026-07-31',
      '2026-08-01',
      '2026-08-02',
      '2026-08-03',
      '2026-08-04',
      '2026-08-05',
      '2026-08-06',
      '2026-08-07',
      '2026-08-08',
      '2026-08-09',
      '2026-08-10',
      '2026-08-11',
      '2026-08-12',
    ],
    yAxis: [
      1.93, 1.96, 1.88, 2.15, 2.11, 1.99, 1.92, 1.99, 1.92, 1.9, 2.12, 2.16, 1.9, 2, 1.93, 1.99,
      1.96, 2.21, 2.22, 2.01, 1.92, 1.94, 1.89, 1.96, 2.13, 2.16, 1.89, 1.88, 1.89, 1.96, 1.93,
      2.13, 2.13, 1.95, 1.87, 1.86, 1.86, 1.92, 2.07, 2.12, 1.84, 1.85, 1.94, 1.91, 1.92, 2.04,
      2.14, 1.81, 1.83, 1.8, 1.82, 1.86, 2.02, 2.08, 1.85, 1.85, 1.74, 1.82, 1.73, 2.03, 1.92, 1.74,
      1.74, 1.71, 1.68, 1.71, 1.97, 1.91, 1.68, 1.6, 1.6, 1.7, 1.61, 1.85, 1.81, 1.64, 1.58, 1.58,
      1.62, 1.53, 1.74, 1.74, 1.55, 1.54, 1.49, 1.52, 1.42, 1.73, 1.64, 1.46, 1.44, 1.43, 1.42, 1.4,
      1.56, 1.55, 1.37, 1.36, 1.35, 1.34, 1.26, 1.48, 1.48, 1.3, 1.28, 1.23, 1.24, 1.18, 1.37, 1.37,
      1.12, 1.21, 1.15, 1.14, 1.14, 1.27, 1.26, 1.09, 1.05, 1.07, 1.04, 1.05, 1.25, 1.25, 0.93,
      0.93, 0.93, 0.99, 0.91, 1.15, 1.16, 0.87, 0.93, 0.84, 0.85, 0.83, 1.05, 1.07, 0.85, 0.81,
      0.81, 0.85, 0.73, 1.04, 1, 0.74, 0.7, 0.72, 0.7, 0.75, 0.88, 0.96, 0.7, 0.66, 0.71, 0.67, 0.6,
      0.82, 0.81, 0.67, 0.64, 0.6, 0.59, 0.63, 0.85, 0.84, 0.51, 0.61, 0.53, 0.57, 0.56, 0.72, 0.8,
      0.54, 0.52, 0.49, 0.5, 0.54, 0.7, 0.71, 0.46, 0.43, 0.43, 0.45, 0.47, 0.65, 0.68, 0.47, 0.51,
      0.47, 0.45, 0.46, 0.7, 0.7, 0.4, 0.44, 0.39, 0.44, 0.49, 0.65, 0.68, 0.42, 0.5, 0.41, 0.51,
      0.46, 0.74, 0.7, 0.5, 0.41, 0.49, 0.45, 0.47, 0.68, 0.65, 0.48, 0.48, 0.49, 0.48, 0.44, 0.69,
      0.74, 0.45, 0.47, 0.52,
    ],
  },
  MONTH: {
    xAxis: [
      '31.7 23:00',
      '1.8 00:00',
      '1.8 01:00',
      '1.8 02:00',
      '1.8 03:00',
      '1.8 04:00',
      '1.8 05:00',
      '1.8 06:00',
      '1.8 07:00',
      '1.8 08:00',
      '1.8 09:00',
      '1.8 10:00',
      '1.8 11:00',
      '1.8 12:00',
      '1.8 13:00',
      '1.8 14:00',
      '1.8 15:00',
      '1.8 16:00',
      '1.8 17:00',
      '1.8 18:00',
      '1.8 19:00',
      '1.8 20:00',
      '1.8 21:00',
      '1.8 22:00',
      '1.8 23:00',
      '2.8 00:00',
      '2.8 01:00',
      '2.8 02:00',
      '2.8 03:00',
      '2.8 04:00',
      '2.8 05:00',
      '2.8 06:00',
      '2.8 07:00',
      '2.8 08:00',
      '2.8 09:00',
      '2.8 10:00',
      '2.8 11:00',
      '2.8 12:00',
      '2.8 13:00',
      '2.8 14:00',
      '2.8 15:00',
      '2.8 16:00',
      '2.8 17:00',
      '2.8 18:00',
      '2.8 19:00',
      '2.8 20:00',
      '2.8 21:00',
      '2.8 22:00',
      '2.8 23:00',
      '3.8 00:00',
      '3.8 01:00',
      '3.8 02:00',
      '3.8 03:00',
      '3.8 04:00',
      '3.8 05:00',
      '3.8 06:00',
      '3.8 07:00',
      '3.8 08:00',
      '3.8 09:00',
      '3.8 10:00',
      '3.8 11:00',
      '3.8 12:00',
      '3.8 13:00',
      '3.8 14:00',
      '3.8 15:00',
      '3.8 16:00',
      '3.8 17:00',
      '3.8 18:00',
      '3.8 19:00',
      '3.8 20:00',
      '3.8 21:00',
      '3.8 22:00',
      '3.8 23:00',
      '4.8 00:00',
      '4.8 01:00',
      '4.8 02:00',
      '4.8 03:00',
      '4.8 04:00',
      '4.8 05:00',
      '4.8 06:00',
      '4.8 07:00',
      '4.8 08:00',
      '4.8 09:00',
      '4.8 10:00',
      '4.8 11:00',
      '4.8 12:00',
      '4.8 13:00',
      '4.8 14:00',
      '4.8 15:00',
      '4.8 16:00',
      '4.8 17:00',
      '4.8 18:00',
      '4.8 19:00',
      '4.8 20:00',
      '4.8 21:00',
      '4.8 22:00',
      '4.8 23:00',
      '5.8 00:00',
      '5.8 01:00',
      '5.8 02:00',
      '5.8 03:00',
      '5.8 04:00',
      '5.8 05:00',
      '5.8 06:00',
      '5.8 07:00',
      '5.8 08:00',
      '5.8 09:00',
      '5.8 10:00',
      '5.8 11:00',
      '5.8 12:00',
      '5.8 13:00',
      '5.8 14:00',
      '5.8 15:00',
      '5.8 16:00',
      '5.8 17:00',
      '5.8 18:00',
      '5.8 19:00',
      '5.8 20:00',
      '5.8 21:00',
      '5.8 22:00',
      '5.8 23:00',
      '6.8 00:00',
      '6.8 01:00',
      '6.8 02:00',
      '6.8 03:00',
      '6.8 04:00',
      '6.8 05:00',
      '6.8 06:00',
      '6.8 07:00',
      '6.8 08:00',
      '6.8 09:00',
      '6.8 10:00',
      '6.8 11:00',
      '6.8 12:00',
      '6.8 13:00',
      '6.8 14:00',
      '6.8 15:00',
      '6.8 16:00',
      '6.8 17:00',
      '6.8 18:00',
      '6.8 19:00',
      '6.8 20:00',
      '6.8 21:00',
      '6.8 22:00',
      '6.8 23:00',
      '7.8 00:00',
      '7.8 01:00',
      '7.8 02:00',
      '7.8 03:00',
      '7.8 04:00',
      '7.8 05:00',
      '7.8 06:00',
      '7.8 07:00',
      '7.8 08:00',
      '7.8 09:00',
      '7.8 10:00',
      '7.8 11:00',
      '7.8 12:00',
      '7.8 13:00',
      '7.8 14:00',
      '7.8 15:00',
      '7.8 16:00',
      '7.8 17:00',
      '7.8 18:00',
      '7.8 19:00',
      '7.8 20:00',
      '7.8 21:00',
      '7.8 22:00',
      '7.8 23:00',
      '8.8 00:00',
      '8.8 01:00',
      '8.8 02:00',
      '8.8 03:00',
      '8.8 04:00',
      '8.8 05:00',
      '8.8 06:00',
      '8.8 07:00',
      '8.8 08:00',
      '8.8 09:00',
      '8.8 10:00',
      '8.8 11:00',
      '8.8 12:00',
      '8.8 13:00',
      '8.8 14:00',
      '8.8 15:00',
      '8.8 16:00',
      '8.8 17:00',
      '8.8 18:00',
      '8.8 19:00',
      '8.8 20:00',
      '8.8 21:00',
      '8.8 22:00',
      '8.8 23:00',
      '9.8 00:00',
      '9.8 01:00',
      '9.8 02:00',
      '9.8 03:00',
      '9.8 04:00',
      '9.8 05:00',
      '9.8 06:00',
      '9.8 07:00',
      '9.8 08:00',
      '9.8 09:00',
      '9.8 10:00',
      '9.8 11:00',
      '9.8 12:00',
      '9.8 13:00',
      '9.8 14:00',
      '9.8 15:00',
      '9.8 16:00',
      '9.8 17:00',
      '9.8 18:00',
      '9.8 19:00',
      '9.8 20:00',
      '9.8 21:00',
      '9.8 22:00',
      '9.8 23:00',
      '10.8 00:00',
      '10.8 01:00',
      '10.8 02:00',
      '10.8 03:00',
      '10.8 04:00',
      '10.8 05:00',
      '10.8 06:00',
      '10.8 07:00',
      '10.8 08:00',
      '10.8 09:00',
      '10.8 10:00',
      '10.8 11:00',
      '10.8 12:00',
      '10.8 13:00',
      '10.8 14:00',
      '10.8 15:00',
      '10.8 16:00',
      '10.8 17:00',
      '10.8 18:00',
      '10.8 19:00',
      '10.8 20:00',
      '10.8 21:00',
      '10.8 22:00',
      '10.8 23:00',
      '11.8 00:00',
      '11.8 01:00',
      '11.8 02:00',
      '11.8 03:00',
      '11.8 04:00',
      '11.8 05:00',
      '11.8 06:00',
      '11.8 07:00',
      '11.8 08:00',
      '11.8 09:00',
      '11.8 10:00',
      '11.8 11:00',
      '11.8 12:00',
      '11.8 13:00',
      '11.8 14:00',
      '11.8 15:00',
      '11.8 16:00',
      '11.8 17:00',
      '11.8 18:00',
      '11.8 19:00',
      '11.8 20:00',
      '11.8 21:00',
      '11.8 22:00',
      '11.8 23:00',
      '12.8 00:00',
      '12.8 01:00',
      '12.8 02:00',
      '12.8 03:00',
      '12.8 04:00',
      '12.8 05:00',
      '12.8 06:00',
      '12.8 07:00',
      '12.8 08:00',
    ],
    yAxis: [
      15.8, 6.9, 6.9, 6.8, 7, 8.8, 15.3, 33.9, 47.8, 47.3, 32.9, 19.8, 13, 11.4, 11.3, 12.1, 15.2,
      23.3, 40.2, 59.4, 77, 76.4, 61.5, 39.5, 22.5, 6.7, 7, 6.9, 7, 8.6, 15.1, 34.2, 49.9, 49.1,
      33.4, 19.4, 13.4, 11.4, 11.6, 12.1, 14.8, 23.2, 38.9, 62.3, 76.1, 75.6, 60.5, 38.2, 23.4, 4.7,
      4.6, 4.8, 4.9, 6, 10.6, 23.5, 33.7, 33.9, 23.4, 13.6, 9.1, 8, 8.1, 8.2, 10.2, 15.7, 27.4,
      42.2, 52.4, 51.6, 41.2, 26.8, 16.3, 4.8, 4.7, 4.7, 4.9, 5.9, 10.6, 23.5, 32.9, 33.1, 23.8,
      13.7, 9.2, 7.8, 7.8, 8.2, 10.1, 15.9, 26.8, 40.7, 52.8, 54.1, 41.4, 27, 16.2, 4.9, 4.9, 4.8,
      5, 6.1, 10.3, 23.9, 33.4, 33.4, 23.6, 13.4, 9.1, 8.3, 8.1, 8.7, 10.5, 15.7, 26.7, 43.1, 54,
      52.3, 41.7, 27.6, 16.2, 4.9, 4.9, 4.7, 5, 6.2, 10.3, 23.5, 34.9, 33.4, 23.8, 14, 9.3, 7.9,
      7.9, 8.7, 10.8, 16.5, 28.2, 41.6, 55.4, 53.1, 43.5, 27.6, 15.9, 4.9, 4.8, 4.8, 4.9, 6.1, 10.7,
      23.6, 34, 34.5, 23.7, 13.7, 9.6, 8.4, 8.1, 8.6, 10.8, 16.6, 27.1, 42.9, 53.3, 54.8, 43.4,
      27.5, 16.3, 7, 7.2, 7, 7.3, 9.1, 16.1, 35.7, 49, 49.1, 36, 20.4, 14, 12, 12.1, 12.7, 15.6,
      23.5, 40.9, 64, 77.5, 77.4, 64.2, 40.9, 24.5, 7.2, 7.2, 7.3, 7.6, 8.9, 15.5, 34.6, 50.2, 50.7,
      35.3, 21, 13.4, 12.2, 12.1, 12.5, 15.9, 24.5, 39.8, 63.4, 78, 80.6, 61.4, 41.8, 24.7, 5.1, 5,
      4.8, 5.1, 6.2, 10.7, 24.3, 35.1, 34.9, 24.2, 13.9, 9.7, 8.4, 8.4, 9, 11.2, 16.5, 28.9, 44.1,
      57.5, 57.5, 45.4, 29.2, 17.2, 5.1, 4.9, 5.1, 5.2, 6.5, 11.4, 25.5, 36.4, 36, 24.7, 14.5, 9.8,
      8.5, 8.6, 9.2, 10.9, 16.6, 28.9, 43.3, 57.3, 57.9, 43.7, 29.1, 17.5, 5.2, 5.2, 5.1, 5.3, 6.3,
      11.1, 24.7, 36.5, 36.7,
    ],
  },
  WEEK: {
    xAxis: [
      'Sun 9 Aug 23:30',
      'Mon 10 Aug 00:00',
      'Mon 10 Aug 00:30',
      'Mon 10 Aug 01:00',
      'Mon 10 Aug 01:30',
      'Mon 10 Aug 02:00',
      'Mon 10 Aug 02:30',
      'Mon 10 Aug 03:00',
      'Mon 10 Aug 03:30',
      'Mon 10 Aug 04:00',
      'Mon 10 Aug 04:30',
      'Mon 10 Aug 05:00',
      'Mon 10 Aug 05:30',
      'Mon 10 Aug 06:00',
      'Mon 10 Aug 06:30',
      'Mon 10 Aug 07:00',
      'Mon 10 Aug 07:30',
      'Mon 10 Aug 08:00',
      'Mon 10 Aug 08:30',
      'Mon 10 Aug 09:00',
      'Mon 10 Aug 09:30',
      'Mon 10 Aug 10:00',
      'Mon 10 Aug 10:30',
      'Mon 10 Aug 11:00',
      'Mon 10 Aug 11:30',
      'Mon 10 Aug 12:00',
      'Mon 10 Aug 12:30',
      'Mon 10 Aug 13:00',
      'Mon 10 Aug 13:30',
      'Mon 10 Aug 14:00',
      'Mon 10 Aug 14:30',
      'Mon 10 Aug 15:00',
      'Mon 10 Aug 15:30',
      'Mon 10 Aug 16:00',
      'Mon 10 Aug 16:30',
      'Mon 10 Aug 17:00',
      'Mon 10 Aug 17:30',
      'Mon 10 Aug 18:00',
      'Mon 10 Aug 18:30',
      'Mon 10 Aug 19:00',
      'Mon 10 Aug 19:30',
      'Mon 10 Aug 20:00',
      'Mon 10 Aug 20:30',
      'Mon 10 Aug 21:00',
      'Mon 10 Aug 21:30',
      'Mon 10 Aug 22:00',
      'Mon 10 Aug 22:30',
      'Mon 10 Aug 23:00',
      'Mon 10 Aug 23:30',
      'Tue 11 Aug 00:00',
      'Tue 11 Aug 00:30',
      'Tue 11 Aug 01:00',
      'Tue 11 Aug 01:30',
      'Tue 11 Aug 02:00',
      'Tue 11 Aug 02:30',
      'Tue 11 Aug 03:00',
      'Tue 11 Aug 03:30',
      'Tue 11 Aug 04:00',
      'Tue 11 Aug 04:30',
      'Tue 11 Aug 05:00',
      'Tue 11 Aug 05:30',
      'Tue 11 Aug 06:00',
      'Tue 11 Aug 06:30',
      'Tue 11 Aug 07:00',
      'Tue 11 Aug 07:30',
      'Tue 11 Aug 08:00',
      'Tue 11 Aug 08:30',
      'Tue 11 Aug 09:00',
      'Tue 11 Aug 09:30',
      'Tue 11 Aug 10:00',
      'Tue 11 Aug 10:30',
      'Tue 11 Aug 11:00',
      'Tue 11 Aug 11:30',
      'Tue 11 Aug 12:00',
      'Tue 11 Aug 12:30',
      'Tue 11 Aug 13:00',
      'Tue 11 Aug 13:30',
      'Tue 11 Aug 14:00',
      'Tue 11 Aug 14:30',
      'Tue 11 Aug 15:00',
      'Tue 11 Aug 15:30',
      'Tue 11 Aug 16:00',
      'Tue 11 Aug 16:30',
      'Tue 11 Aug 17:00',
      'Tue 11 Aug 17:30',
      'Tue 11 Aug 18:00',
      'Tue 11 Aug 18:30',
      'Tue 11 Aug 19:00',
      'Tue 11 Aug 19:30',
      'Tue 11 Aug 20:00',
      'Tue 11 Aug 20:30',
      'Tue 11 Aug 21:00',
      'Tue 11 Aug 21:30',
      'Tue 11 Aug 22:00',
      'Tue 11 Aug 22:30',
      'Tue 11 Aug 23:00',
      'Tue 11 Aug 23:30',
      'Wed 12 Aug 00:00',
      'Wed 12 Aug 00:30',
      'Wed 12 Aug 01:00',
      'Wed 12 Aug 01:30',
      'Wed 12 Aug 02:00',
      'Wed 12 Aug 02:30',
      'Wed 12 Aug 03:00',
      'Wed 12 Aug 03:30',
      'Wed 12 Aug 04:00',
      'Wed 12 Aug 04:30',
      'Wed 12 Aug 05:00',
      'Wed 12 Aug 05:30',
      'Wed 12 Aug 06:00',
      'Wed 12 Aug 06:30',
      'Wed 12 Aug 07:00',
      'Wed 12 Aug 07:30',
      'Wed 12 Aug 08:00',
      'Wed 12 Aug 08:30',
    ],
    yAxis: [
      9.5, 2.5, 2.5, 2.4, 2.5, 2.4, 2.4, 2.5, 2.7, 3.1, 3.9, 5.4, 7.8, 12.2, 15.4, 17.8, 19, 17.3,
      15.5, 12.3, 9.7, 7.3, 5.8, 4.9, 4.5, 4.3, 4.2, 4.2, 4.1, 4.5, 5, 5.5, 6.5, 8.5, 10.9, 14.3,
      18.5, 22.1, 25.4, 27.5, 28.3, 28, 25.7, 21.4, 18.2, 13.9, 11.2, 8.4, 6.6, 2.5, 2.4, 2.5, 2.5,
      2.5, 2.6, 2.6, 2.8, 3.2, 4, 5.6, 8, 12.4, 15.7, 18.3, 18.3, 17.4, 15.5, 12.1, 9.6, 7.4, 5.6,
      4.9, 4.6, 4.4, 4.2, 4.3, 4.2, 4.4, 4.9, 5.5, 6.5, 8.4, 10.8, 14.5, 18.6, 22.9, 26.3, 28.9, 29,
      28.8, 25.8, 22.1, 18.8, 14.5, 11.1, 8.7, 6.8, 2.6, 2.6, 2.5, 2.5, 2.5, 2.5, 2.6, 2.8, 3.3, 4,
      5.5, 7.9, 12.4, 16.1, 18.1, 18.9, 18, 15.4,
    ],
  },
  DAY: {
    xAxis: [
      '00:00',
      '00:15',
      '00:30',
      '00:45',
      '01:00',
      '01:15',
      '01:30',
      '01:45',
      '02:00',
      '02:15',
      '02:30',
      '02:45',
      '03:00',
      '03:15',
      '03:30',
      '03:45',
      '04:00',
      '04:15',
      '04:30',
      '04:45',
      '05:00',
      '05:15',
      '05:30',
      '05:45',
      '06:00',
      '06:15',
      '06:30',
      '06:45',
      '07:00',
      '07:15',
      '07:30',
      '07:45',
      '08:00',
      '08:15',
      '08:30',
      '08:45',
    ],
    yAxis: [
      1.3, 1.3, 1.3, 1.3, 1.2, 1.2, 1.2, 1.3, 1.3, 1.2, 1.3, 1.3, 1.3, 1.4, 1.4, 1.5, 1.6, 1.8, 2.1,
      2.4, 2.8, 3.4, 3.9, 4.8, 6.3, 7.1, 7.9, 8.3, 9.2, 9.3, 9.6, 9.2, 8.8, 8.6, 7.8, 7.2,
    ],
  },
};

export const getLinePlaceholderConfig = (
  dependencies: { translocoService: TranslocoService },
  options: {
    colors: {
      line: string;
      areaStop1: string;
      areaStop2: string;
    };
    granularity: ConsumptionFilter['granularity'];
  },
): echarts.EChartsOption => ({
  grid: {
    left: 56,
    right: 24,
    top: 40,
    bottom: 44,
  },
  xAxis: {
    type: 'category',
    boundaryGap: false,
    data: data[options.granularity].xAxis,
    axisTick: {
      show: false,
    },
    axisLabel: {
      show: false,
    },
  },
  yAxis: {
    type: 'value',
    name: dependencies.translocoService.translate('cockpit.analysis.consumption.graph.yAxisLabel'),
    axisLabel: {
      show: false,
    },
  },
  series: [
    {
      type: 'line',
      smooth: 0.25,
      symbol: 'none',
      emphasis: {
        disabled: true,
      },
      data: data[options.granularity].yAxis,
      lineStyle: {
        color: options.colors.line,
        width: 1,
        type: [2, 3],
      },
      itemStyle: {
        color: options.colors.line,
      },
      areaStyle: {
        color: {
          type: 'linear',
          x: 0,
          y: 0,
          x2: 0,
          y2: 1,
          colorStops: [
            {
              offset: 0,
              color: options.colors.areaStop1,
            },
            {
              offset: 1,
              color: options.colors.areaStop2,
            },
          ],
        },
      },
    },
  ],
});
